import React from "react";
import { View, TouchableOpacity } from "react-native";
import StyledText from "../../common/ui/styled-text";
import { useRouter } from "expo-router";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { useSettingsData } from "../../../contexts/SettingsDataContext";

export default function PaymentBanner() {
  const router = useRouter();
  const { stripeAccountStatus } = useSettingsData();
  const { isPaymentsFeatureEnabled } = useFeatureFlags();
  if (!isPaymentsFeatureEnabled()) {
    return null;
  }

  // dont show banner if stripe account is already setup
  if (stripeAccountStatus === "READY") {
    return null;
  }

  const handleGoToEarnings = () => {
    router.push("/earnings");
  };

  return (
    <View className="bg-gradient-to-r from-emerald-50 to-emerald-50 border border-emerald-200 rounded-lg p-3 shadow-sm">
      <View className="flex flex-row items-center gap-3">
        <View className="flex-1">
          <View className="flex flex-row items-center gap-2 mb-1">
            <StyledText className="text-base font-semibold text-emerald-800">
              Payments Now Available! 🎉
            </StyledText>
          </View>
          <View className="flex flex-row items-center gap-1">
            <StyledText className="text-sm text-emerald-700">
              <TouchableOpacity onPress={handleGoToEarnings}>
                <StyledText className="text-sm text-emerald-700 underline">
                  Set up
                </StyledText>
              </TouchableOpacity>{" "}
              your earnings account to enable payments
            </StyledText>
          </View>
        </View>
      </View>
    </View>
  );
}
